import { render, staticRenderFns } from "./page-terms.vue?vue&type=template&id=6c96e949&"
import script from "./page-terms.vue?vue&type=script&lang=js&"
export * from "./page-terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports